"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MercanetResponseMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class MercanetResponseMapper {
    toDomain(result) {
        const method = lodash_1.default.get(result, 'data.mercanetV2.method');
        const uri = lodash_1.default.get(result, 'data.mercanetV2.uri');
        const body = lodash_1.default.get(result, 'data.mercanetV2.body');
        return {
            method,
            uri,
            body,
        };
    }
}
exports.MercanetResponseMapper = MercanetResponseMapper;
